import { deleteApiWrapper, getApiWrapper, postApiWrapper, putApiWrapper } from "./token-wrapper-function";

const base_url = 'https://y71-dashboard.y-71.com'

export const loginUser = async (credentials) => {
    const response = await postApiWrapper(`${base_url}/login`, credentials);
    return response;
}